import { CardList } from './components/card-list/card-list.component';
import React,{ Component } from 'react';
import {SearchBox} from './components/search-box/search-box.component';
import './App.css';

class App extends Component{
  constructor(){
    super();
    this.state={
monsters:[],
searchField:""
    }
  }

  componentDidMount(){
    fetch('https://jsonplaceholder.typicode.com/users')
    .then(response => response.json())
    .then(users => this.setState({monsters:users}));
  }

  render(){
    const {monsters,searchField} =this.state;
    const filteredmonsters=monsters.filter(monster => monster.name.toLowerCase().includes(searchField.toLowerCase())
    );

    return (
      <div className="App">
        <h1 className='h11'>Monsters Rolodex</h1>
        <SearchBox  
            placeholder="search a monster"
            handleChange={e=>{
              this.setState({searchField:e.target.value})}}/>
        <CardList monsters={filteredmonsters}/>
      </div>
    );
  }
   
}
  /*function App() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
      </div>
    );
  }*/

export default App;
